import TlajoLogo from '../../../../../Assets/Images/logo-02.png'
import moment from 'moment'
import { useEffect, useRef } from 'react'
import { useReactToPrint } from 'react-to-print'
import KpiCustomGraphicLine from '../../ReportsCounters/components/KpiCustomGraphicLine'
import KpiCustomGraphicBar from '../../ReportsCounters/components/KpiCustomGraphicBar'
import KpiMultiCards from '../../ReportsCounters/components/KpiMultiCards'

const WaterTruckRequestPdfTemplate = ({
  filters = {
    array_group_category_id: null,
    date_type: 'ALL',
    year: new Date().getFullYear().toString(),
    month: null,
    week: null,
  },
  pdfController = {
    loading: false,
    hideElements: false,
    notes: null,
  },
  counters = {
    generated: 0,
    resolved: 0,
    effectiveness: 0,
    web: 0,
    app: 0,
    tlajochat: 0,
    categories: [],
    categoriesOrigin: [],
    counterByDateFilter: null,
    counterByDateFilterLines: null,
    counterByDateFilterLinesOptions: null,
    countersByDateFilterPie: null,
    countersByDateFilterPieOptions: null,
  },
  options = {
    categories: [],
    years: [],
    months: [],
    weeks: [],
  },
}) => {
  let monthsName = [
    'Enero',
    'Febrero',
    'Marzo',
    'Abril',
    'Mayo',
    'Junio',
    'Julio',
    'Agosto',
    'Septiembre',
    'Octubre',
    'Noviembre',
    'Diciembre',
  ]
  const contentRef = useRef(null)

  const reactToPrintFn = useReactToPrint({
    contentRef,
    documentTitle: `${
      (filters?.week ? `Semana${filters.week}-` : '') +
      (filters?.month ? `${monthsName[filters.month - 1]}-` : '') +
      (filters?.year ? `${filters?.year}-` : '')
    }reporte-actividad`,
    pageStyle: `
        @media print {
          .counters-page-break {
            page-break-after: always;
            break-after: page;
          }
        }
      `,
  })

  useEffect(() => {
    if (pdfController.loading) {
        setTimeout(() => {
        reactToPrintFn()
        }, 1000)
    }
  }, [pdfController.loading])

  const formatNumberWithCommas = (number) => {
    if (typeof number !== 'number') return number
    return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
  }

  return (
    <>
      <div
        ref={contentRef}
        className="admin-master-mayor-pdf-template px-5 py-5"
      >
        <div className="col-12 header-box-pdf">
          <div className="row">
            <div className="col-12 mb-4">
              <img src={TlajoLogo} alt="tlajo-logo" />
              <span>{moment().format('DD/MM/YYYY')}</span>
            </div>
            <div className="col-5 box-left">
              <div className="row">
                <div className="col-6">
                  <span className="title">Periodo</span>
                </div>
                <div className="col-6">
                  <span className="subtitle">
                    {filters?.date_type === 'ALL'
                      ? 'Generales'
                      : filters?.date_type === 'YEAR'
                      ? 'Anuales'
                      : filters?.date_type === 'MONTH'
                      ? 'Mensuales'
                      : filters?.date_type === 'WEEK'
                      ? 'Semanales'
                      : filters?.date_type === 'DAY'
                      ? 'Diarios'
                      : 'Generales'}
                  </span>
                </div>
              </div>
              <div className="row">
                <div className="col-6">
                  <span className="title">Vista por</span>
                </div>
                <div className="col-6">
                  {filters?.year && (
                    <>
                      <span className="subtitle">Año {filters?.year}</span>
                      <br />
                    </>
                  )}
                  {filters?.month && (
                    <>
                      <span className="subtitle">
                        Mes {monthsName[filters.month - 1]}
                      </span>
                      <br />
                    </>
                  )}
                  {filters?.week && (
                    <>
                      <span className="subtitle">Semana {filters?.week}</span>
                      <br />
                    </>
                  )}
                </div>
              </div>
            </div>
            {pdfController.notes && (
              <div className="col-7 box-right p-3">
                <h5 className="mt-2">Observaciones</h5>
                <p>{pdfController.notes}</p>
              </div>
            )}
          </div>
        </div>

        {/** Data and Graphics */}
        <div className="col-12 col-sm-12 col-md-9 col-lg-9 col-xl-9">
          {/**Counters */}
          <div className="row">
            <div className={`col-12 cards-box`}>
              <KpiMultiCards
                cards={[
                  {
                    title: 'Sistema de indicadores',
                    value: `${
                      counters?.generalPercentage
                        ? counters?.generalPercentage >= 80
                          ? 'Bueno'
                          : counters?.generalPercentage >= 60
                          ? 'Normal'
                          : 'Regular'
                        : 'Regular'
                    }`,
                    iconContent: <i className="fas fa-check colorGreen" />,
                  },
                  {
                    title: 'Procentaje General',
                    value: `${counters?.generalPercentage || 0}%`,
                    iconContent: <i className="fas fa-check colorGreen" />,
                  },
                ]}
              />
            </div>
          </div>

          <div className="row">
            {/**Graphics */}
            <div className="row graphics-box-container">
              {counters?.counterByDateFilter && (
                <div className="graphics-box col-12 counters-page-break">
                  <div className="header">
                    <h5 className="text-left">
                      Reportes{' '}
                      {filters?.date_type === 'ALL'
                        ? 'Generales'
                        : filters?.date_type === 'YEAR'
                        ? 'Anuales'
                        : filters?.date_type === 'MONTH'
                        ? 'Mensuales'
                        : filters?.date_type === 'WEEK'
                        ? 'Semanales'
                        : filters?.date_type === 'DAY'
                        ? 'Diarios'
                        : 'Generales'}
                    </h5>
                  </div>

                  <div className="body">
                    <div className={`legend-pdf`}>
                      <div className="legend-item mr-3">
                        <h5>Generados</h5>
                        <p>{formatNumberWithCommas(counters?.generated)}</p>
                      </div>
                      <div className="legend-item mr-3">
                        <h5>Resueltos</h5>
                        <p>{formatNumberWithCommas(counters?.resolved)}</p>
                      </div>
                      <div className="legend-item">
                        <h5>Efectividad</h5>
                        <p>{counters?.effectiveness}%</p>
                      </div>
                    </div>
                    <div className="chart">
                      <KpiCustomGraphicBar
                        barDataStatus={counters?.counterByDateFilter}
                        barOptions={{
                          ...counters?.counterByDateFilterOptions,
                        }}
                      />
                    </div>
                  </div>
                </div>
              )}
              <div className="graphics-box col-12 mt-3">
                <div className="header">
                  <h5 className="text-left">
                    % de resueltos{' '}
                    {filters?.date_type === 'ALL'
                      ? 'total'
                      : filters?.date_type === 'YEAR'
                      ? 'anuales'
                      : filters?.date_type === 'MONTH'
                      ? 'mensuales'
                      : filters?.date_type === 'WEEK'
                      ? 'semanales'
                      : filters?.date_type === 'DAY'
                      ? 'diarios'
                      : 'total'}
                  </h5>
                </div>
                <div className="body">
                  <div className="chart">
                    <KpiCustomGraphicLine
                      lineData={counters?.counterByDateFilterLines}
                      lineOptions={counters?.counterByDateFilterLinesOptions}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default WaterTruckRequestPdfTemplate
